/* ZCT_V22_START (E2): Startseite, Verhalten wie Home und ZenRoom in v21.
   - zct-hero (JS-015): Video beim Start abspielen; scheitert das (z. B. Stromsparmodus), erscheint der Play-Knopf
     .hero-play-btn direkt nach dem Video. Am Ende von vorn, bei stalled/waiting nach 1 s erneut, beim Zurückkehren
     in den Tab erneut. Klick auf den Knopf spielt ab und entfernt ihn.
   - zct-zenraum (JS-017): Hover und Fokus auf Pin oder Karte setzen active, dim, visible und has-active wie in v21. */
(function () {
  'use strict';
  // Bewegung komplett: Zeit-Token lesen; Shopify liefert das CSS verkleinert aus (200ms wird .2s), daher Sekunden und Millisekunden
  function zdZeit(v) { v = String(v || '').trim(); var x = parseFloat(v); if (isNaN(x)) return NaN; return /ms$/i.test(v) ? x : (/s$/i.test(v) ? x * 1000 : x); }
  function zctT(k) { try { var el = document.getElementById('zct-texte'), d = el ? JSON.parse(el.textContent) : {}; var v = d[k]; if (typeof v === 'string' && v.indexOf('&') >= 0) { var t = document.createElement('textarea'); t.innerHTML = v; v = t.value; } return v == null ? '' : v; } catch (e) { return ''; } }

  class ZctHero extends HTMLElement {
    connectedCallback() {
      var v = this.querySelector('video.hero-bg');
      if (!v) return;
      this.ab = new AbortController();
      var s = { signal: this.ab.signal };
      var knopf = null;
      function zeigeKnopf() {
        if (knopf) return;
        knopf = document.createElement('button');
        knopf.className = 'hero-play-btn';
        knopf.setAttribute('aria-label', zctT('v25_video_abspielen')); // E7: je Sprache
        knopf.innerHTML = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="23" stroke="rgba(255,255,255,0.6)" stroke-width="1.5"></circle><polygon points="19,15 35,24 19,33" fill="#fff"></polygon></svg>';
        knopf.addEventListener('click', function () {
          v.dataset.zctGestartet = '1';
          v.play().then(function () { if (knopf) { knopf.remove(); knopf = null; } }).catch(function () {});
        });
        v.after(knopf);
      }
      // Paket D (J11): bei „Bewegung reduzieren“ kein automatisches Abspielen, Standbild mit Abspiel-Knopf
      var ruhig = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      // v26: Pause-Knopf (Figma); angehalten bleibt angehalten, auch bei Tabwechsel oder Hängern
      var pause = this.querySelector('[data-zd-pause]');
      function pauseZeichnen() { if (!pause) return; var an = v.paused; /* Bewegung komplett (Plan 012): echter Zustand, auch bei „Bewegung reduzieren“ oder gescheitertem Autoplay */ pause.setAttribute('aria-pressed', String(an)); pause.setAttribute('aria-label', an ? pause.getAttribute('data-label-play') : pause.getAttribute('data-label-pause')); pause.classList.toggle('is-angehalten', an); }
      if (pause) pause.addEventListener('click', function () {
        if (v.paused) { delete v.dataset.zdAngehalten; v.dataset.zctGestartet = '1'; v.play().catch(function () {}); if (knopf) { knopf.remove(); knopf = null; } }
        else { v.dataset.zdAngehalten = '1'; v.pause(); }
        pauseZeichnen();
      }, s);
      v.addEventListener('play', pauseZeichnen, s); v.addEventListener('pause', pauseZeichnen, s); pauseZeichnen();
      function versuch() { if (v.dataset.zdAngehalten) return; if (ruhig && !v.dataset.zctGestartet) { v.pause(); zeigeKnopf(); return; } var p = v.play(); if (p && p.catch) p.catch(zeigeKnopf); }
      v.muted = true;
      if (ruhig) { v.removeAttribute('autoplay'); v.pause(); }
      // Teil B1: Das Video lädt erst, wenn das Poster (größtes Element der Seite) da ist oder die Seite fertig geladen ist,
      // damit es dem Poster keine Bandbreite wegnimmt. Bewegung-reduzieren-Nutzer starten weiter selbst (Knopf).
      if (v.hasAttribute('data-zd-spaeter')) {
        var gestartet = false;
        var los = function () { if (gestartet) return; gestartet = true; if (!ruhig) v.preload = 'auto'; versuch(); };
        if (document.readyState === 'complete') los();
        else {
          window.addEventListener('load', los, { once: true });
          var bild = new Image(); bild.onload = function () { setTimeout(los, 300); }; bild.src = v.getAttribute('poster');
        }
      } else versuch();
      v.addEventListener('ended', function () { v.currentTime = 0; versuch(); }, s);
      var haenger = function () { setTimeout(function () { if (v.paused) versuch(); }, 1000); };
      v.addEventListener('stalled', haenger, s);
      v.addEventListener('waiting', haenger, s);
      document.addEventListener('visibilitychange', function () { if (!document.hidden && v.paused) versuch(); }, s);
    }
    disconnectedCallback() { if (this.ab) this.ab.abort(); }
  }

  class ZctZenraum extends HTMLElement {
    connectedCallback() {
      var stage = this.querySelector('.stage');
      if (!stage) return;
      this.ab = new AbortController();
      var s = { signal: this.ab.signal };
      var pins = Array.prototype.slice.call(this.querySelectorAll('a.pin'));
      var karten = Array.prototype.slice.call(this.querySelectorAll('a.pin-card'));
      var aktiv = null;
      function zeichnen() {
        var sk = 'stage ' + (aktiv ? 'has-active' : '');
        if (stage.className !== sk) stage.className = sk;
        pins.forEach(function (p) {
          var id = p.getAttribute('data-zct-pin');
          var dir = (p.className.match(/dir-[\w-]+/) || ['dir-left'])[0];
          var k = 'pin ' + dir + ' ' + (aktiv === id ? 'active' : '') + ' ' + (aktiv && aktiv !== id ? 'dim' : '');
          if (p.className !== k) p.className = k;
        });
        karten.forEach(function (c) {
          var id = c.getAttribute('data-zct-pin');
          var dir = (c.className.match(/dir-[\w-]+/) || ['dir-left'])[0];
          var k = 'pin-card ' + dir + ' ' + (aktiv === id ? 'visible' : '');
          if (c.className !== k) c.className = k;
        });
      }
      function setze(id) { aktiv = id; zeichnen(); }
      // Bewegung komplett (Plan 011): Gnadenzeit beim Verlassen (--zd-dauer-fenster), damit die Karte 24 px über dem Punkt mit der Maus
      // erreichbar ist (vorher schloss sie beim Verlassen des Punkts sofort); Betreten von Punkt oder Karte hält sie offen
      var uhrZu = 0;
      function sofort(id) { clearTimeout(uhrZu); setze(id); }
      function spaeterZu() { clearTimeout(uhrZu); uhrZu = setTimeout(function () { setze(null); }, (zdZeit(getComputedStyle(document.documentElement).getPropertyValue('--zd-dauer-fenster')) || 250)); }
      pins.forEach(function (p) {
        var id = p.getAttribute('data-zct-pin');
        p.addEventListener('mouseenter', function () { sofort(id); }, s);
        p.addEventListener('mouseleave', spaeterZu, s);
        p.addEventListener('focus', function () { sofort(id); }, s);
        p.addEventListener('blur', spaeterZu, s);
      });
      karten.forEach(function (c) {
        var id = c.getAttribute('data-zct-pin');
        c.addEventListener('mouseenter', function () { sofort(id); }, s);
        c.addEventListener('mouseleave', spaeterZu, s);
        c.addEventListener('focus', function () { sofort(id); }, s);
        c.addEventListener('blur', spaeterZu, s);
      });
    }
    disconnectedCallback() { if (this.ab) this.ab.abort(); }
  }

  if (!customElements.get('zct-hero')) customElements.define('zct-hero', ZctHero);
  if (!customElements.get('zct-zenraum')) customElements.define('zct-zenraum', ZctZenraum);
})();
